'use client';

import { useSetAtom } from 'jotai';
import { CtaReview } from '@sapientpro/sapientpro-data-models';
import styles from './TextReviewCardSection.module.scss';
import contactModalTriggerButton from '../../store/contactForm';
import Button, { ButtonVariants } from '../Button';

const TextReviewCardContactButton = ({ ctaButton }: { ctaButton: CtaReview['ctaButton'] }) => {
  const setContactsModalTrigger = useSetAtom(contactModalTriggerButton);

  const handleJoinUsClick = () => {
    setContactsModalTrigger('shared.cta-review');
  };

  return (
    <Button
      className={styles.textReviewCard__button}
      variant={ButtonVariants.PRIMARY}
      icon={(
        <svg
          className={styles.textReviewCard__buttonIcon}
          viewBox='0 0 24 24'
        >
          <use
            xlinkHref='/media/arrow-right-bold.svg#arrowRight'
            href='/media/arrow-right-bold.svg#arrowRight'
          />
        </svg>
                  )}
      iconPosition='right'
      iconSize={{ width: 24, height: 24 }}
      onClick={handleJoinUsClick}
    >
      {ctaButton}
    </Button>
  );
};

export default TextReviewCardContactButton;
